/// <amd-module name="Test/TestPlansLibrary/Pivots/TestCasesPivot/Redux/TestCasesModule" />
import { ISagaModule } from "redux-dynamic-modules-saga";
import { ActionsUnion } from "redux/Utils/ActionHelper";
import { TestCasesActions } from "../Redux/TestCasesActions";
import { ITestCasesAwareState } from "../Redux/TestCasesContracts";
import { TestCasesReducer } from "../Redux/TestCasesReducer";
import { TestCasesSaga } from "../Redux/TestCasesSaga";
import { TestPlansLibraryReducer } from "Test/TestPlansLibrary/LibraryHub/Redux/TestPlansLibraryReducer";

// initializes the test cases pivot module
export function getTestCasesModule(): ISagaModule<ITestCasesAwareState> {
    const initialActions: ActionsUnion<typeof TestCasesActions>[] = [];
    initialActions.push(TestCasesActions.initializeTestCasesPivot(), TestCasesActions.loadInitialTestCases());

    return {
        id: "testcases-pivot",
        reducerMap: {
            testCasesState: TestCasesReducer,
            testPlansLibraryState: TestPlansLibraryReducer
        },
        sagas: [TestCasesSaga],
        initialActions: initialActions
    };
}
